
    import { defineComponent, PropType } from 'vue'
    import { useRouter } from 'vue-router'
    import { Button } from '@progress/kendo-vue-buttons'

    export default defineComponent({
        name: 'LinkButton',

        components: {
            'k-button': Button
        },

        props: {
            caption: { type: String as PropType<string>, required: true },
            routeName: { type: String as PropType<string>, default: undefined },
            href: { type: String as PropType<string>, default: undefined },
            disabled: { type: Boolean as PropType<boolean>, default: false }
        },

        emits: {
            click: () => true
        },

        setup(props, { emit }) {
            const router = useRouter()

            function onClick() {
                if (props.href != null) {
                    window.location.href = props.href
                } else if (props.routeName != null) {
                    router.push({ name: props.routeName })
                } else {
                    emit('click')
                }
            }

            return { onClick }
        }
    })
